<template lang="pug">
.wrapper.row.items-start.catalog.relative-position.q-pt-md
    .full-width.row
        .col-6.q-my-md
            .row
                h1.q-my-none.text-primary.font-22.text-weight-medium(ref="title")
                    | {{ currentCategory.name }}
                sup.text-grey.font-14.q-pl-md.text-weight-regular {{ productsCount }} {{ productsCountText }}
        .row.col-6.justify-end.items-center.q-pb-md(v-if="localProducts.length")
            sorting-desktop.q-mr-sm(
                ref="sorting"
                width="190")
            q-btn.float-right(
                flat
                fab-mini
                @click="isVertical = !isVertical")
                q-icon(
                    size="18px"
                    color="positive"
                    :name="isVertical ? 'etabl:blocks' : 'etabl:list'")
    .full-width.q-mb-lg.q-pb-sm
        base-breadcrumbs(:routeObj="routeObj" catalog)
        .row.q-mt-lg(v-if="currentCategory?.bread_crumbs[0].name == 'Оптика'")
            .col-8
                q-img(src="optika/banner-desktop.webp" alt="Баннер оптика" title="Оптика: Видите мир яснее с нашими услугами и продукцией").q-mb-lg.b-radius-16
            .col-4.q-pl-lg.q-pb-lg
                .q-card.bg-secondary.b-radius-16.full-height.full-width.q-pa-lg.text-primary
                    .font-18.line-height-28.text-weight-bold.q-mt-sm
                        | Запись на консультацию к
                        br
                        | врачу-офтальмологу
                    .font-12.line-height-20.q-my-md(v-if="userAuthorized")
                        | Проверка зрения длится около 30 минут и включает в себя все необходимые
                        | тесты. Выберите ближайший салон и удобное время!
                    .font-12.line-height-20.q-my-md(v-else)
                        | Чтобы записаться на прием к врачу-офтальмологу,  Вам необходимо пройти
                        | процесс авторизации или регистрации.
                    base-btn(
                        :label="userAuthorized ? 'Выберите адрес салона' : 'Войти'"
                        height="40"
                        bradius="20"
                        @click="userAuthorized ? goToAppointment('/appointment-optics') : showAuth()"
                    ).q-mb-sm
        .row.q-mt-lg(v-if="currentCategory?.bread_crumbs[0].name == 'Ортопедия'")
            .col-8
                q-img(src="orthopedics/banner-desktop.webp" alt="Баннер ортопедия" title="Ортопедия: Заботьтесь о своем здоровье с нашими инновационными решениями").q-mb-lg.b-radius-16
            .col-4.q-pl-lg.q-pb-lg
                .q-card.bg-secondary.b-radius-16.full-height.full-width.q-pa-lg.text-primary
                    .font-18.line-height-28.text-weight-bold.q-mt-sm
                        | Запись на индивидуальное изготовление стелек
                    .font-12.line-height-20.q-my-md(v-if="userAuthorized")
                        | Процесс изготовления длится не менее 40 минут и включает в себя все необходимые процедуры.
                        | Выберите ближайший салон и удобное время!
                    .font-12.line-height-20.q-my-md(v-else)
                        | Чтобы записаться на индивидуальное изготовление стелек,  Вам необходимо
                        | пройти процесс авторизации или регистрации.
                    base-btn(
                        :label="userAuthorized ? 'Выберите адрес салона' : 'Войти'"
                        height="40"
                        bradius="20"
                        @click="userAuthorized ? goToAppointment('/appointment-orthopedics') : showAuth()"
                    ).q-mb-sm
        .row.iris-banner-wrap
            div.desktop-full.q-mt-lg#adfox_173504687401219080

    .col-3.q-pr-md.relative-position
        .font-16.text-weight-medium.q-mb-md(v-if="!freeDelivery")
        router-link.link.row.font-16.text-weight-medium.text-primary.q-mb-md.items-center(
            v-if="freeDelivery"
            to="/free-catalog"
            title="Каталог бесплатной доставки")
            q-icon.category__tree-icon(
                name="etabl:arrow_prev"
                size="xs")
            span
                | Категории
        .category__tree
            .category__tree-item.row.items-center.cursor-pointer(v-if="currentCategory.parent_category")
                router-link.text-primary(
                    v-if="currentCategory.parent_category.code"
                    :to="`${currentCategory.parent_category.slug_name}?freeDelivery=${freeDelivery}`"
                    :title="`${currentCategory.name}`")
                    .row.items-center.no-wrap
                        q-icon.category__tree-icon(
                            name="etabl:arrow_prev"
                            size="xs")
                        div
                            span {{ currentCategory.parent_category.name }}
                            // span.q-pl-sm(v-if="cat.free_delivered_count") ({{ cat.free_delivered_count }})
                // .text-primary.cursor-default.row.items-center(v-else)
                //     q-icon.category__tree-icon(
                //         name="etabl:arrow_prev"
                //         size="xs"
                //         v-if="currentCategory.code !== cat.id")
                //     div
                //         span {{ cat.name }}
                //         span.q-pl-sm(v-if="cat.free_delivered_count") ({{ cat.free_delivered_count }})
            .category__tree-sub-items
                router-link.text-primary.active(
                    :to="`${currentCategory.slug_name}?freeDelivery=${freeDelivery}`"
                    :title="`${currentCategory.name}`")
                    span {{ currentCategory.name }}
            .category__tree-sub-items(v-if="currentCategory.child_categories")
                template(v-for="subCat in currentCategory.child_categories")
                    router-link.text-primary(
                        :class="currentCategory.code === subCat.section_id ? 'active' : ''"
                        :to="`${subCat.slug_name}?freeDelivery=${freeDelivery}`"
                        :title="`${subCat.name}`")
                        span {{ subCat.name }}
                        span.q-pl-sm(v-if="subCat.free_delivered_count") ({{ subCat.free_delivered_count }})
        .q-pa-md.filter-block(v-if="catalogFilters && !catalogFiltersIsEmpty")

            template(v-for="(filter, key) in catalogFilters" :index="key")
                .q-mb-md.price_range(v-if="filter?.values.length")
                    q-expansion-item(
                        v-if="filter?.key === 'price_range'"
                        default-opened
                        label="Диапазон цен"
                        header-class="text-weight-medium text-primary q-px-xs"
                        dense-toggle
                    )
                        .q-mt-sm(v-if="filter.values.length < 10")
                            .q-mt-sm(v-for="item in filter.values")
                                .row.no-wrap.items-center.cursor-pointer.q-mb-sm.q-pl-xs.cursor-pointer(
                                    v-if="item != ''"
                                )
                                    q-input.col-6(
                                        @keypress="validateKeyPress($event)"
                                        v-model='minPrice'
                                        prefix='От'
                                        suffix='₽'
                                        rounded
                                        outlined
                                        @change="setFilter(priceRange, filter.key)"
                                        :placeholder='minPriceHolder'
                                    )
                                    q-input.col-6(
                                        v-model='maxPrice'
                                        prefix='До'
                                        suffix='₽'
                                        rounded
                                        outlined
                                        @change="setFilter(priceRange, filter.key)"
                                        :placeholder='maxPriceHolder'
                                    )
            template(v-for="(filter, key) in catalogFilters" :index="key")
                .q-mb-md(v-if="filter?.values.length")
                    q-expansion-item(
                        v-if="(filter?.values.find((item) => item.isChecked)) && filter.key !== 'price_range'"
                        default-opened
                        :label="filter.title"
                        header-class="text-weight-medium text-primary q-px-xs"
                        dense-toggle
                    )
                        .q-mt-sm(v-if="filter.values.length < 10")
                            .q-mt-sm(v-for="item in filter.values")
                                .row.no-wrap.items-center.cursor-pointer.q-mb-sm.q-pl-xs.cursor-pointer(
                                    v-if="item != ''"
                                    @click="item.isChecked ? resetFilter(filter.key, index) : setFilter(item.title, filter.key)")
                                    input.check(
                                        type="checkbox"
                                        :checked="item.isChecked"
                                        :ref="`${item.title}-${item}`")
                                    .font-14.q-pl-sm {{ item.title  }}
                        q-scroll-area.full-width(
                            v-else
                            style="height: 300px"
                            :thumb-style="options.thumb"
                            :bar-style="options.bar"
                            :horizontal="false")
                            template(v-for="item in filter.values")
                                .row.no-wrap.items-center.cursor-pointer.q-my-sm.q-pl-xs.cursor-pointer(
                                    @click="item.isChecked ? resetFilter(filter.key, index) : setFilter(item.title, filter.key)")
                                    input.check(type="checkbox" :checked="item.isChecked")
                                    .font-14.q-pl-sm {{ item.title }}
                    q-expansion-item(
                        v-if="filter.key !== 'price_range'"
                        :label="filter.title"
                        header-class="text-weight-medium text-primary q-px-xs"
                        dense-toggle
                    )
                        .q-mt-sm(v-if="filter.values.length < 10")
                            .q-mt-sm(v-for="item in filter.values")
                                .row.no-wrap.items-center.cursor-pointer.q-mb-sm.q-pl-xs.cursor-pointer(
                                    v-if="item != ''"
                                    @click="item.isChecked ? resetFilter(filter.key, index) : setFilter(item.title, filter.key)")
                                    input.check(
                                        type="checkbox"
                                        :checked="item.isChecked"
                                        :ref="`${item.title}-${item}`")
                                    .font-14.q-pl-sm {{ item.title  }}
                        q-scroll-area.full-width(
                            v-else
                            style="height: 300px"
                            :thumb-style="options.thumb"
                            :bar-style="options.bar"
                            :horizontal="false")
                            template(v-for="item in filter.values")
                                .row.no-wrap.items-center.cursor-pointer.q-my-sm.q-pl-xs.cursor-pointer(
                                    @click="item.isChecked ? resetFilter(filter.key, index) : setFilter(item.title, filter.key)")
                                    input.check(type="checkbox" :checked="item.isChecked")
                                    .font-14.q-pl-sm {{ item.title }}
                                .row.no-wrap.items-center.cursor-pointer.q-my-sm.q-pl-xs.cursor-pointer(
                                    @click="item.isChecked ? resetFilter(filter.key, index) : setFilter(item.title, filter.key)")

        .row.iris-banner-wrap
            div.desktop-long.q-pt-lg#adfox_173504687295649080
    .col-9.q-pl-md
        .row.items-center.q-gutter-x-md
            template(v-for="(filter, key) in filtersFromURL")
                template(
                    v-for="(item, index) in filter"
                    :key="item + index")
                    .row.items-center.justify-between.filter-short
                        span.text-secondary.text-weight-medium.font-14(v-if="key != 'number'") {{ item }}
                        span.text-secondary.text-weight-medium.font-14(v-else) N{{ item }}
                        q-btn.filter-short__close(
                            flat
                            fab-mini
                            @click="resetFilter(key, index)")
                            q-icon(
                                name="etabl:cross"
                                size="xs"
                                color="secondary")
            .row.items-center.justify-between.filter-short.filter-short-gray(v-if="filtersLength > 1")
                .text-grey-12.text-weight-medium.font-16.cursor-pointer(@click="localResetAllFilters") Сбросить фильтры
        .q-mt-xl.column.items-center.justify-center(v-if="showReset")
            q-img.empty-img(src="interface/search-empty.svg" no-spinner alt="Ничего не нашлось" title="Ничего не обнаружено")
            .font-20.text-weight-medium.q-mt-lg
                | Ничего не нашлось
            .q-mt-sm(v-if="filtersLength")
                | Попробуйте
                span.link(@click="localResetAllFilters") сбросить фильтры
        product-list-desktop(
            :loading="loading"
            :products="localProducts"
            :totalCount="productsCount"
            :emptyList="!localProducts.length"
            :showMoreLoading="showMoreLoading"
            :isVertical="isVertical"
            @setPagination="setPagination"
        )
        .q-mt-xl.text-primary.custom-html.q-pb-md(v-if="currentCategory?.seo_content" v-html="currentCategory.seo_content")
    .col-12.carousel.q-my-lg(v-if="history?.length && userAuthorized")
        product-slider-desktop(
            label="Вы недавно просматривали"
            :slides="history"
            :manufacture="true")
</template>

<script>
import { deepCopy } from 'assets/helpers';
import { resetlAllFilters } from 'assets/helpers/catalog.js';
import MiniSearch from 'minisearch';
import { scroll, useQuasar } from 'quasar';
import { computed, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import BaseBreadcrumbs from 'components/Base/BaseBreadcrumbs.vue';
import SortingDesktop from 'components/Sorting/SortingDesktop.vue';
import ProductListDesktop from 'components/ProductList/ProductListDesktop.vue';
import ProductSliderDesktop from 'components/ProductSlider/ProductSliderDesktop.vue';
import BaseBtn from 'src/components/Base/BaseBtn.vue';

const { getScrollTarget, setVerticalScrollPosition } = scroll;


export default {
    name: 'CatalogDesktop',
    components: {
        SortingDesktop,
        BaseBreadcrumbs,
        ProductListDesktop,
        ProductSliderDesktop,
        BaseBtn,
    },

    setup() {
        const $q = useQuasar();
        const route = useRoute();
        const store = useStore();
        const router = useRouter();

        const sorting = ref();
        const showMore = ref(false);
        const isVertical = ref(true);
        const showMoreLoading = ref(false);

        // опции для scroll-area
        const options = ref({
            thumb: {
                right: '0px',
                borderRadius: '4px',
                backgroundColor: '#fff',
                width: '10px',
                opacity: 1,
                boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                border: '1px solid #E9E9E9',
            },
            bar: {
                right: '0px',
                borderRadius: '4px',
                backgroundColor: '#E9E9E9',
                width: '10px',
                opacity: 1,
            },
        });

        // состояние загрузки
        const loading = computed(() => showMore.value ? false : store.getters['catalog/LOADING']);

        // продукты
        const products = computed(() => store.getters['catalog/PRODUCTS']);

        // бесплатная доставка
        const freeDelivery = computed(() => store.getters['categories/FREE_DELIVERY']);

        // текущая категория
        const currentCategory = computed(() => store.getters['categories/CURRENT_NCATEGORY']);

        // хлебные крошки
        const routeObj = computed(() => currentCategory.value.bread_crumbs);

        // отображение "сбросить фильтры"
        const showReset = computed(() => store.getters['productList/SHOW_RESET']);

        // категории id:url
        const categoriesIdToUrl = computed(() => store.getters['categories/CATEGORIES_ID_TO_URL']);

        // кол-во товаров
        const productsCount = computed(() => store.getters['catalog/PRODUCTS_COUNT']);

        // дерево категорий
        const categoryTree = computed(() => store.getters['catalog/CATEGORY_TREE']);

        // дочерние категории
        const nestedCategories = computed(() => store.getters['catalog/NESTED_CATEGORIES']);

        const categoryCeo = computed(() => store.getters['categories/CATEGORIES_META']);

        // фильтры каталога
        const catalogFilters = ref(null);

        // пустые ли фильтры
        const catalogFiltersIsEmpty = computed(() => store.getters['catalog/CATALOG_FILTERS_IS_EMPTY']);

        // получаем фильтры из URL
        const filtersFromURL = computed(() => store.getters['catalog/FILTERS_FROM_URL']);

        // авторизован ли пользователь
        const userAuthorized = computed(() => store.getters['user/USER_AUTHORIZED']);

        const history = computed(() => store.getters['advertisement/HISTORY']);

        const localProducts = ref(products.value);
        const groupCategory = ref(null);

        // город пользователя
        const city = computed(() => store.getters['cityForm/CITY']);

        // фильтр по цене

        const priceRangeFilter = ref([]);
        const priceRangeValue = ref('');
        const priceRange = computed(() => {
            if (minPrice.value || maxPrice.value) {
                return `${minPrice.value},${maxPrice.value}`;
            }
            return null;
        });
        const validateKeyPress = (event) => {
            if (event.key.length === 1 && !/[0-9]/.test(event.key)) {
                event.preventDefault();
            }
        };
        const minPrice = ref('');
        const maxPrice = ref('');
        const minPriceHolder = computed(() => {
            return priceRangeValue.value ? priceRangeValue.value.value.split(',')[0] : '';
        });
        const maxPriceHolder = computed(() => {
            return priceRangeValue.value ? priceRangeValue.value.value.split(',')[1] : '';
        });
        const indexPrice = ref('');

        watch(() => products.value, (value,oldValue) => {
            showMoreLoading.value = false;
            let changeCategory = false;
            if (oldValue[0].groupCategory.title !== value[0].groupCategory.title){
                changeCategory = true;
            }
            if (showMore.value && !changeCategory){
                localProducts.value.push(...value);
            }else{
                localProducts.value = [];
                localProducts.value = value;
            }
        });
        watch(
            () => [minPrice.value, maxPrice.value],
            ([newMinPrice, newMaxPrice]) => {
                minPrice.value = minPrice.value === '' ? minPriceHolder.value : minPrice.value;
                maxPrice.value = maxPrice.value === '' ? maxPriceHolder.value : maxPrice.value;
                priceRange.value = `${newMinPrice},${newMaxPrice}`;
            },
        );

        watch(
            () => catalogFilters.value,
            () => {
                priceRangeFilter.value = ref(catalogFilters.value?.find((item, index) => item.key == 'price_range'));
                indexPrice.value = ref(catalogFilters.value?.findIndex((item, index) => item.key == 'price_range'));
                priceRangeValue.value = ref(priceRangeFilter.value?.value?.values[0].title);

            },
        );

        // кол-во применённых фильтров
        const filtersLength = computed(() => {
            let length = 0;

            for (let item in filtersFromURL.value) {
                length += filtersFromURL.value[item].length;
            }

            return length;
        });

        // инициализируем поиск по фильтрам
        const searchInit = (filter) => {
            if (!filter.minisearch) {
                let miniSearch = new MiniSearch({
                    fields: ['value'],
                    storeFields: ['value'],
                });
                filter.miniSearch = miniSearch;
                filter.miniSearch.addAll(filter.items);
            }
        };

        // поиск по фильтрам
        const searchFilter = (value, filter) => {
            filter.query = value;

            if (!value) {
                filter.nothing = false;
                // если строка поиска пуста - показываем все фильтры
                filter.items.forEach((item) => item.show = true);
            } else {
                filter.nothing = true;
                // поиск фильтров
                const result = filter.miniSearch.search(value, {
                    prefix: true,
                });

                // прям изначально все элементы
                filter.items.forEach((item) => item.show = false);

                // отображаем только те фильтры, которые нашлись
                result.forEach((res) => {
                    filter.items.forEach(item => {
                        if (item.id == res.id) {
                            item.show = true;
                            filter.nothing = false;
                        }
                    });
                });
            }
        };

        const activeFilters = ref([]);

        // устанавливаем фильтр
        const setFilter = async (item, parent) => {
            const copyQuery = deepCopy(route.query);

            // обнуляем номер страницы
            copyQuery.page = 1;

            copyQuery[parent] = item;

            activeFilters.value[parent] = item;

            await updateResults(copyQuery, 500);
        };

        // сбрасываем фильтр
        const resetFilter = async (key, index, item = null) => {
            // создаём копию route
            const copyQuery = deepCopy(route.query);

            // обнуляем номер страницы
            copyQuery.page = 1;

            if (item) {
                typeof copyQuery[item.filter.type] == 'string'
                    ? delete copyQuery[item.filter.type]
                    : copyQuery[item.filter.type] = copyQuery[item.filter.type]
                        .filter((el) => el !== item.item.value);
            } else {
                typeof copyQuery[key] == 'string'
                    ? delete copyQuery[key]
                    : copyQuery[key].splice(index, 1);
            }

            await updateResults(copyQuery, 0);
        };

        // обновляем результаты поиска
        const updateResults = async (query, delay) => {
            setTimeout(() => {
                router.push({
                    query: {
                        ...query,
                    },
                });
            }, delay);

            if (!showMore.value) goTop();
        };

        watch(route, () => {
            catalogFilters.value = null;

            setTimeout(() => {
                catalogFilters.value = store.getters['catalog/CATALOG_FILTERS'];
            }, 1);

        });

        // сбрасываем все фильтры
        const localResetAllFilters = async () => {
            showMore.value = false;
            // создаём копию route
            const result = resetlAllFilters(deepCopy(route.query));

            await updateResults(result, 0);
        };

        // прокрутка вверх
        const goTop = () => {
            const target = getScrollTarget(document.querySelector('#q-app'));
            setVerticalScrollPosition(target, 0, 300);
        };

        // управление пагинацией
        const setPagination = ({ page, letsShowMore }) => {
            // если была нажата кнопка показать еще - кэшируем предыдущие результаты
            showMore.value = letsShowMore;
            showMoreLoading.value = true;

            // создаём копию route
            const copyQuery = deepCopy(route.query);
            copyQuery.page = page;

            updateResults(copyQuery, 0);
        };

        const productsCountText = computed(() => {
            let n = Math.abs(productsCount.value) % 100;
            let n1 = n % 10;

            if (n > 10 && n < 20) {
                return 'товаров';
            } else if (n1 > 1 && n1 < 5) {
                return 'товара';
            } else if (n1 == 1) {
                return 'товар';
            } else {
                return 'товаров';
            }
        });

        const fitlersOpen = (item) => {
            return item.isChecked;
        };

        const showAuth = () => {
            store.commit('auth/SET_ENTRY_AUTH', 'signin');
        };

        const goToAppointment = (val) => {
            router.push(city.value ? `/${city.value.slug}${val}` : val);
        };

        onMounted(() => {
            catalogFilters.value = store.getters['catalog/CATALOG_FILTERS'];
            if (process.env.CLIENT) {
                window.yaContextCb.push(() => {
                    Ya.adfoxCode.create({
                        ownerId: 5202103,
                        containerId: 'adfox_173504687295649080',
                        params: {
                            p1: 'dfnuz',
                            p2: 'ixfw',
                        },
                    });
                    // Ya.adfoxCode.create({
                    //     ownerId: 5202103,
                    //     containerId: 'adfox_173504658480499080',
                    //     params: {
                    //         p1: 'dfnut',
                    //         p2: 'ixfw',
                    //     },
                    // });
                    Ya.adfoxCode.create({
                        ownerId: 5202103,
                        containerId: 'adfox_173504687401219080',
                        params: {
                            p1: 'dfnva',
                            p2: 'ixfw',
                        },
                    });
                });
                setTimeout(() => {
                    document.querySelectorAll('.iris-banner-wrap').forEach((elem) => {
                        if (elem.firstChild && elem.firstElementChild.firstChild) {
                            elem.firstElementChild.classList.add('not-empty');
                        }
                    });
                }, 1500);
            }
        });

        return {
            validateKeyPress,
            loading,
            sorting,
            options,
            routeObj,
            products,
            showReset,
            setFilter,
            searchInit,
            isVertical,
            categoryCeo,
            resetFilter,
            searchFilter,
            categoryTree,
            freeDelivery,
            localProducts,
            filtersLength,
            setPagination,
            productsCount,
            catalogFilters,
            filtersFromURL,
            showMoreLoading,
            currentCategory,
            nestedCategories,
            categoriesIdToUrl,
            productsCountText,
            localResetAllFilters,
            catalogFiltersIsEmpty,
            activeFilters,
            fitlersOpen,
            userAuthorized,
            history,
            priceRange,
            minPrice,
            maxPrice,
            minPriceHolder,
            maxPriceHolder,
            priceRangeValue,
            priceRangeFilter,
            indexPrice,
            showAuth,
            goToAppointment,
            city,
            groupCategory,
        };
    },
};
</script>

<style lang="scss" scoped>
.catalog {
    min-height: 400px;
}

.filter-block {
    background: $secondary;
    border-radius: $mobile-border-radius;
    box-shadow: 2px 4px 16px rgba(0, 0, 0, 0.07);
}

.product {
    &__list {
        @media screen and (max-width: $breakpoint-mobile) {
            padding: 0 15px !important;
            margin-top: 74px;
        }
    }

    &__wrapper {
        margin-top: 24px;
    }
}

.filter {
    &__list {
        @media screen and (max-width: $breakpoint-mobile) {
            padding: 0 15px !important;
        }
    }

    &__wrapper {
        @media screen and (max-width: $breakpoint-mobile) {
            box-shadow: rgba(33, 35, 38, 0.1) 0px 10px 10px -10px;
            z-index: 900;
            position: fixed;
            top: 46px;
            width: 100% !important;
            z-index: 4000;
            background-color: $secondary;
        }
    }
}

.q-infinite-scroll :deep(.q-infinite-scroll__loading) {
    width: 100%;
}

:deep .filter-short {
    height: 33px;
    background-color: $positive;
    border-radius: 16px;
    padding-left: 15px;
    margin-bottom: 12px;
    max-width: 300px;

    &-gray {
        background-color: $accent;
        padding: 0 15px;
    }

    & > span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 5px;
        max-width: 86%;
    }

    .q-btn {
        min-height: 30px !important;
        min-width: 30px !important;
    }
}

.category {
    &__filter {
        padding-right: 30px;
    }

    &__filter-list {
        height: 250px;
        width: 100%;

        &-short {
            height: auto;
            overflow: hidden;
        }
    }

    &__filter-more {
        @media screen and (max-width: $breakpoint-mobile) {
            margin-bottom: 16px;
        }
        @media (max-width: 1280px) {
            font-size: 14px !important;
        }
        @media (max-width: 960px) {
            font-size: 12px !important;
        }
    }


    &__tree {
        margin-bottom: 11px;

        &-item {
            & > a {
                color: $primary;
                line-height: 22px;
                margin: 0;
                text-decoration: none;
                display: block;
                width: 100%;
                padding: 3px 0;
                margin-bottom: 2px;
                border-radius: 6px;

                font: {
                    size: 16px;
                    weight: 400;
                    size: 14px;
                }
                @media (max-width: 1280px) {
                    font-size: 14px;
                }
                @media (max-width: 960px) {
                    font-size: 12px;
                }
            }

            &-active {
                padding-left: 21px !important;
                background: rgba(34, 189, 119, 0.2);
            }
        }

        &-icon {
            font-size: 14px !important;
            margin-right: 7px;
        }
    }

    &__tree-sub-items {
        padding-left: 10px;

        a {
            color: $primary;
            line-height: 22px;
            margin-top: 5px;
            padding: 4px 19px;
            text-decoration: none;
            display: block;

            font: {
                size: 14px;
                weight: 400;
            }
            @media (max-width: 1280px) {
                font-size: 14px;
            }
            @media (max-width: 960px) {
                font-size: 12px;
            }

            &.active,
            &:hover {
                background: rgba(34, 189, 119, 0.2);
                border-radius: 6px;
            }

        }
    }
}

.filter-block {
    margin-top: 33px;

    @media screen and (max-width: $breakpoint-mobile) {
        margin-top: 0;
    }


    &:last-of-type {
        margin-bottom: 33px;

        @media screen and (max-width: $breakpoint-mobile) {
            margin-bottom: 110px;
        }
    }

    &__apply {
        z-index: 980;
        position: fixed;
        bottom: 100px;
        width: calc(100% - 30px) !important;
    }

    &__back {
        z-index: 980;
        position: fixed;
        bottom: 50px;
        width: calc(100% - 30px) !important;
    }
}

.product-spinner {
    top: 50px;
}

.apply-absolute {
    position: absolute;
    z-index: 999;
    width: 110px !important;
    transform: translateY(-50%);
    transition: $main-transition;

    &::after {
        content: "";
        position: absolute;
        width: 8px;
        height: 8px;
        background-color: $positive;
        left: 0;
        top: 50%;
        transform: translateX(-50%) translateY(-50%) rotate(45deg);
    }
}

:deep(.q-checkbox__bg) {
    border-width: 1px;
}

.check {
    width: 16px;
    height: 16px;
    accent-color: $positive;
}

.price_range .q-field :deep(.q-field__control) {
    max-width: 80%;
    height: 40px;
}


</style>
